import Firebase from '../../../lib/Firebase';

export default {
  saveCityInformation(hotelId, contact) {
    const cityObj = {
      contact,
      };

    return Firebase.firestore()
      .collection('hotels')
      .doc(hotelId)
      .update(cityObj);
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotel/Contact/service.js